// Library methods
import { useTranslation } from "react-i18next";

// MUI Components
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

// Styles
import {
  ModalCustomCancel,
  ModalCustomConfirm,
} from "../../../styles/muiStylesHelper";
import DefaultModal from "../DefaultModal";
import Alert from "../Alert";

const SharedDeleteModal = ({
  open,
  onClose,
  onConfirm,
  onCancel,
  titleKey,
  descriptionKey,
  progressionAnalysisFound,
  progressionAnalysisFoundCount,
}) => {
  // internationalization
  const { t } = useTranslation();

  return (
    <DefaultModal
      isOpen={open}
      onClose={onClose}
      title={t(titleKey)}
      maxWidth="xs"
      modalActions={
        <Grid
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "20px",
          }}
        >
          <Button variant="text" sx={ModalCustomCancel} onClick={onCancel}>
            {t("button_cancel")}
          </Button>
          <Button
            variant="outlined"
            sx={ModalCustomConfirm}
            onClick={onConfirm}
          >
            {t("button_delete")}
          </Button>
        </Grid>
      }
    >
      <Grid p="20px" display="flex" flexDirection="column" gap="20px">
        {progressionAnalysisFound && (
          <Alert
            variant="warning"
            alertContent={
              progressionAnalysisFoundCount === 1
                ? t("analysis_status_check_warning")
                : t("analysis_status_check_warning_for_plural")
            }
          />
        )}

        <Typography>{t(descriptionKey)}</Typography>
      </Grid>
    </DefaultModal>
  );
};

export default SharedDeleteModal;
